import { ChangeEvent } from "react";
import { FormControlModel } from "types";
import TextField from "../atoms/TextField";
import { useField } from "formik";
import get from "lodash/get";

const TextFieldForm = ({
  name,
  label,
  formik,
  disabled,
  maxLength,
  questionData,
  type = "text",
  onBlurCallback,
  visible = true,
}: FormControlModel) => {
  const [field, meta] = useField(name);
  if (!questionData) return <></>;
  return visible ? (
    <TextField
      name={name}
      type={type}
      label={label}
      margin='normal'
      disabled={disabled}
      id={questionData.id}
      maxLength={maxLength}
      value={formik.values[name]?.value || ""}
      onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
        formik.setFieldValue(name, {
          value: target.value,
          questionID: questionData.id,
        });
      }}
      onBlur={(e: ChangeEvent<HTMLInputElement>) => {
        if (onBlurCallback && typeof onBlurCallback === "function") onBlurCallback(e.target.value as string);
      }}
      error={meta.touched && Boolean(get(meta.error, "value"))}
      helperText={meta.touched && get(meta.error, "value")}
    />
  ) : null;
};

export default TextFieldForm;
